import React from 'react'
import { dataTypes } from '@adalo/constants'
import { getIcon } from 'utils/icons'
// import { buildScheduleNotificationSource } from 'utils/sources'

import Icon from 'components/Shared/Icon'

// Predefined response structure for Schedule Notification
export const SCHEDULE_NOTIFICATION_OUTPUTS = {
  jobId: {
    key: 'jobId',
    name: 'Job ID',
    type: dataTypes.TEXT,
    sampleValue: 'repeat:abc123:1234567890',
  },
}

/**
 * Returns options for schedule notification output properties
 * @param {*} options
 */
export const getTypeOptions = (options = []) => {
  const labels = options.map(option => {
    if (option !== null) return option.label
  })

  const optionsWithIcon = options.map((option, i) => {
    if (option === null) return option

    const label = labels[i]
    const icon = getIcon(option.value, option.label)

    option = {
      ...option,
      label: (
        <div className="schedule-notification-type-option">
          <Icon type={icon} />
          {label}
        </div>
      ),
    }

    return option
  })

  return optionsWithIcon
}

export const getScheduleNotificationOutputOptions = allowedDataTypes => {
  const options = []
  const outputs = SCHEDULE_NOTIFICATION_OUTPUTS

  for (const outputId of Object.keys(outputs)) {
    if (allowedDataTypes.includes(outputs[outputId].type)) {
      const label = outputs[outputId].name

      options.push({
        label,
        outputId,
        ...outputs[outputId],
      })
    }
  }

  return options
}
